import { pushCellHistory } from "../pushCellHistory";
import { State } from "../types";

export type ClearCellsAction = Readonly<{
  type: "CLEAR CELLS";
}>;

export const clearCells = (state: State, _action: ClearCellsAction): State => {
  const cells: State["cells"] = [
    {
      maxX: state.zoneWidth,
      maxY: state.zoneHeight,
      minX: 0,
      minY: 0,
      selectedBorder: null,
    },
  ];
  return pushCellHistory(state, cells, {});
};
